import style from './style.css';
import React from 'preact/compat';

const SeoFooterContent = () => {
  return (
    <div className={style.seoContentContainer} style={'display:none'}>
      <h2 className={`${style.seoContentHeading}`}>Popular Merchants</h2>
      <div className={`${style.seoContentDesc}`}>
        <div>
          <a
            className={`${style.quickLinkFirst}`}
            href='/how-to-buy/flipkart?utm_campaign=instaCred'>
            Flipkart
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/amazon?utm_campaign=instaCred'>
            Amazon
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/myntra?utm_campaign=instaCred'>
            Myntra
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/tata-cliq?utm_campaign=instaCred'>
            Tata Cliq
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/mmt?utm_campaign=instaCred'>
            MakeMyTrip
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/vijaysales?utm_campaign=instaCred'>
            Vijay Sales
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/sangeetha-mobiles?utm_campaign=instaCred'>
            Sangeetha Mobiles
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/poorvika?utm_campaign=instaCred'>
            Poorvika Mobiles
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/dellstore?utm_campaign=instaCred'>
            Dell
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/lenovo?utm_campaign=instaCred'>
            Lenovo
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/decathlon?utm_campaign=instaCred'>
            Decathlon
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/mdcomputers?utm_campaign=instaCred'>
            M D Computers
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/zebrs?utm_campaign=instaCred'>
            Zebrs
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/pepperfry?utm_campaign=instaCred'>
            Pepperfry
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/urbanladder?utm_campaign=instaCred'>
            Urban Ladder
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/royal-oak?utm_campaign=instaCred'>
            Royal Oak
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/ikea?utm_campaign=instaCred'>
            Ikea
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/zefo?utm_campaign=instaCred'>
            Zefo
          </a>
          <a
            className={style.quickLink}
            href='/how-to-buy/curefit?utm_campaign=instaCred'>
            Cult.Fit
          </a>
        </div>
      </div>

      <h1 className={`${style.seoContentHeading}`}>InstaCred Cardless EMI</h1>
      <div className={`${style.seoContentDesc}`}>
        Shop with Cardless EMI at our network of 4800+ top merchants, including
        your favourite e-commerce stores and brands like Amazon, Flipkart,
        Myntra, Tata Cliq, Vijay Sales, MakeMyTrip, Dell, Lenovo, Sangeetha
        Mobiles, Poorvika Mobiles, Decathlon, Pepperfry, Urban Ladder, Cult.Fit,
        Zebrs, and many more. Buy your favourite products across popular
        categories of mobiles, laptops and tablets, electronics and appliances,
        fashion and clothing, home and furnishing, fitness and personal care,
        travel and holidays, and insurance. Check eligibility with the mobile
        number registered with your bank. <a href='/login'>Click Here</a> Now!
      </div>

      <h2 className={`${style.seoContentHeading}`}>Mobile on EMI</h2>
      <div className={`${style.seoContentDesc}`}>
        Buy smartphones or pocket-friendly budget phones of popular brands like
        Xiaomi, Samsung, Oppo, Realme, and Vivo. Shop for premium brands like
        iPhone, OnePlus, or Google Pixel for their state-of-the-art cameras that
        capture high-quality pictures, or get phones with fast processors and
        high ram capacity as per your usage. You can avail of Cardless EMI on
        mobiles across our network of top merchants that include Flipkart,
        Amazon, Tata Cliq, Vijay Sales, Zebrs, Sangeetha Mobiles, and Poorvika
        Mobiles, to name a few. Buy the mobile on your bucket list in a smart
        and affordable way.
      </div>

      <h2 className={`${style.seoContentHeading}`}>Laptops on EMI</h2>
      <div className={`${style.seoContentDesc}`}>
        Buy laptops for work, entertainment, multitasking, or gaming, from
        top-rated and trusted brands like Dell, HP, Lenovo amongst others. Get
        the latest Windows laptops, MacBook, Chromebooks, ssd laptops, or gaming
        laptops in the configuration you desire as per your requirement. With
        InstaCred, you can buy laptops on emi without credit card from Flipkart,
        Amazon, Vijay Sales, Croma, Tata Cliq, Zebrs and other popular
        merchants.
      </div>

      <h2 className={`${style.seoContentHeading}`}>
        Electronics & Appliances on EMI
      </h2>
      <div className={`${style.seoContentDesc}`}>
        Buy Smart TVs, refrigerators, fast-cooling ACs, coolers, air purifiers,
        washing machines, microwaves, OTGs, and other home and kitchen
        appliances you require for your home. Shop for leading brands like
        Samsung, LG, Whirlpool, Philips, Bosch and Godrej on emi without credit
        card available at Flipkart, Amazon, Tata Cliq, Croma, Vijay Sales, Zebrs
        and others.
      </div>

      <h2 className={`${style.seoContentHeading}`}>
        Fashion & Clothing on EMI
      </h2>
      <div className={`${style.seoContentDesc}`}>
        Shop for men, women and kids clothing at leading lifestyle and fashion
        stores. Use Instacred Cardless EMI available at Myntra, Vero Moda, Only,
        Jack & Jones, Zodiac, Raymond, Elitify, Wills Lifestyle, Aza Fashion,
        and many others. Grab trending shoes and sportswear from leading brands
        like Decathlon, Asics, Reebok and Columbia. Apart from modern lifestyle
        and sportswear, you can also pick up trending garments from an array of
        traditional and bridal wear from Kalki, The Chennai Silks, Nalli and
        India Emporium.
      </div>

      <h2 className={`${style.seoContentHeading}`}>
        Home Decor & Furniture on EMI
      </h2>
      <div className={`${style.seoContentDesc}`}>
        Renovating, redecorating or moving to a new place requires a lot of
        thought to get it right. Buy beds, sofa sets, dining tables, wardrobes,
        storage cabinets, study tables, chairs, recliners, TV units, and set up
        your house the way you want. We make shopping for furniture convenient
        and affordable at top merchants like Pepperfry, Urban Ladder, RoyalOak,
        Ikea, Decor, Duroflex, Springtek and Zefo.
      </div>

      <h2 className={`${style.seoContentHeading}`}>
        Flights, Hotels & Holiday Tours on EMI
      </h2>
      <div className={`${style.seoContentDesc}`}>
        Travel for work or pleasure with the convenience of Cardless EMI.
        Whether you are looking to book local and international flights or
        hotels and holiday tours we are available on the most popular travel
        platforms like MakeMyTrip, Via.com, Sasti Ticket, and HappyEasyGo, to
        name a few.
      </div>

      <h2 className={`${style.seoContentHeading}`}>
        Accessories and Watches on EMI
      </h2>
      <div className={`${style.seoContentDesc}`}>
        Up your fashion quotient or gift something special to a dear one with
        trendy accessories, jewellery and watches. Shop for the latest designs
        in watches, bags, wallets and jewellery at popular merchants and brands
        including Amazon, Flipkart, Myntra, Titan, Fossil, Zimson, William Penn,
        and others.
      </div>

      <h2 className={`${style.seoContentHeading}`}>
        Fitness and Personal Care Products on EMI
      </h2>
      <div className={`${style.seoContentDesc}`}>
        Achieve your fitness and wellness goals and get into your desired shape
        mentally and physically. Don’t let expenses hinder your health; get
        fitness and health products like Fitbit or book classes on Cult.Fit with
        Cardless EMI. We make high-value purchases of health and fitness
        products affordable. Shop across popular merchants like Amazon,
        Flipkart, Decathlon, Asics and others.
      </div>

      <h2 className={`${style.seoContentHeading}`}>Insurance on EMI</h2>
      <div className={`${style.seoContentDesc}`}>
        Buy or renew general, health, life, car or travel insurance with the
        comfort of InstaCred Cardless EMI available across top insurance
        companies like HDFC Life Insurance, SBI General Insurance, ICICI Lombard
        GIC Limited, Canara HSBC OBC Life Insurance Company Limited, Shriram
        Life Insurance, Royal Sundaram General Insurance, Bharti Axa, PolicyX
        and Easy Policy.
      </div>
    </div>
  );
};

export default SeoFooterContent;



// WEBPACK FOOTER //
// ./componentsBICRevamp/common/seoFooterContent/index.js